import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import MainSectionLayout from '@Components/MainSectionLayout';
import SMTPSettings from '@Containers/Emails/SMTPSettings';
import { BaseAlertProps } from '@Typings/global.types';

const SMTPSettingsPage: FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation();
  const heading = t('Email.SMTP Settings');

  const [alertState, setAlertState] = useState<BaseAlertProps>({
    openAlert: false,
  });

  return (
    <MainSectionLayout
      heading={heading}
      alertState={alertState}
      filters={<SMTPSettings setAlertState={setAlertState} />}
    />
  );
};

export default SMTPSettingsPage;
